module.exports = __webpack_public_path__ + "static/20-Nurse-Qoins-Persona-9e176e1aa5ca61125773612dbbd9aa1a.jpg";